<template>  
<div> <!-- root element start -->
          <div class="row">
            <div class="col-12">
                <div class="card border-0">
                  <div class="card-header font-weight-bold bg-transparent border-0">
                    <i class="fa fa-plus-circle text-success" aria-hidden="true" @click="changeBottomView('create-include', '','',[])" ></i> 
                    Product Includes <button v-if="orderChangeButton == '1'" class="btn btn-sm btn-primary float-right" @click="updateOrder">Save Order</button></div>

                  <div v-if="includeComp == 0" class="card-body">
                    <div class="col-12 mt-4">
                      <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
                    </div>
                  </div>
                    
                  <div v-if="includeComp == 1" class="card-body border-bottom" style="height:400px; overflow:auto">

                    <draggable
                        @change="orderChange"
                        handle=".handle"
                        :list="includeList"
                    >
                      <div v-for="(inc,index) in includeList" class="row border p-1 mb-1">
                        <div class="col-2">
                          <i class="fa fa-ellipsis-v mr-2 handle" aria-hidden="true"></i>
                          <span class="mr-3">{{ inc.order }}</span>
                        </div>
                        
                        <div class="col-8 text-truncate">
                          {{ inc.name }}
                        </div>
                        <div class="col-2">
                         <a href="#" @click="viewInclude(inc.id)" class=""><i class="fa fa-eye mr-3" aria-hidden="true"  ></i></a>
                          <a href="#" @click="deleteInclude(inc.id)" class="text-danger"><i class="fa fa-trash-o mr-3" aria-hidden="true"></i></a>
                        </div>
                      </div> 
                    </draggable>


                  </div>
                </div>
            </div>
            
          </div>

          <div class="row">
            <transition name="slide-fade" mode="out-in">
                <component 
                  :is="bottomView" 
                  :prop1="bvProp1" 
                  :prop2="bvProp2" 
                  :prop3="bvProp3" 
                  @onSComplete="successComplete" 
                  @onUComplete="unsuccessComplete"
                  @secondaryAction="secondaryAction"
                >
                </component>
              </transition>
          </div>

</div> <!-- root element end -->
</template>


<script>
import draggable from 'vuedraggable'
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/admin-product-single-main-store.js'

import includeCreate from './productIncludesComponents/product-include-create.vue'
import includeView from './productIncludesComponents/product-include-view.vue'
import includeEdit from './productIncludesComponents/product-include-edit.vue'


export default {
  props: ['prod'],
  store,
  data: function () {
    return { 
      bottomView: '',
      bvProp1: '',
      bvProp2: '',
      bvProp3: [],
      loading: 0,
      orderChangeButton: '0',
    }
  },
  computed: {
    detailsList () { return this.$store.state.detailsList },

    includeList () { return this.$store.state.includeList },
    includeComp () { return this.$store.state.includeComp },
    
  },
  watch: {
    
  },
  mounted() {

  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    changeBottomView(name, prop1, prop2, prop3) { this.bottomView = name; this.bvProp1 = prop1; this.bvProp2 = prop2; this.bvProp3 = prop3; },
    getProductIncludes() { this.$store.dispatch("getProductIncludes", { prod: this.detailsList.id }); },

    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'create-include':
          
          _this.changeBottomView('', '', '', []);
          _this.getProductIncludes();
        break;
        case 'edit-include':
          _this.getProductIncludes();
          _this.changeBottomView('', '', '', []);
        break;
        case 'delete-include':
          _this.getProductIncludes();
          _this.changeBottomView('', '', '', []);
        break;
        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'create-include':
          _this.changeBottomView('', '', '', []);
        break;
        case 'edit-include':
          _this.changeBottomView('', '', '', []);
        break;
        case 'view-include':
          _this.changeBottomView('', '', '', []);
        break;
        default:
      }
    },
    secondaryAction(value) {
      var _this = this;
      switch(value[0]) {
        case 1:
        var setup = [value[2]];
          _this.changeBottomView(value[1], '', '', setup);
        break;
        
        default:
      }
    },
    viewInclude(x) {
      var _this = this;
      var setup = [x];
      _this.changeBottomView('view-include', '', '', setup);
    },
    deleteInclude(x) {
      var _this = this;
      _this.changeBottomView('', '', '', []);
      _this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          axios.get('/admin/utility/product/includes/delete/' + x)
          .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.getProductIncludes();
          })
        }
      })
    },


    orderChange() {
      var _this = this;
      _this.orderChangeButton = '1';
      

    },

    updateOrder() {
      var _this = this;
      _this.changeBottomView('', '', '', '');
      _this.loading = 0;
      axios.post( '/admin/utility/product/includes/updatemassorder', {
        list: _this.includeList,
      })
      .then(function(response){
        var msg = response.data.msg;
        _this.getProductIncludes();
        _this.loading = 1;
      }) //end then
      .catch(function (error) {
        var errors = error.response.data.errors;
        _this.errorDisplay(errors);
      })
    },

    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },
    
  },    
  components:{
    draggable,
    ScalingSquaresSpinner,
    'create-include' : includeCreate,
    'view-include' : includeView,
    'edit-include' : includeEdit,
    
  },
  filters: {

  }
}
</script>
